import { getShortcodeWrapper, addShortcodeToEditor } from "../../shortodeAddition";
import { getMultiButtonCtaWithImages } from "../../shortcodes/templates";

const multiButtonWithImagesConfig = (tinymce, uuid, shortcodeOnClick) => {
  const dialogData = {};

  const mainShortcodeConfig = {
    title: "Multi CTA Buttons with images",
    body: {
      type: "panel",
      items: [
        {
          type: "input",
          name: "customUrl",
          label: "Custom URL",
        },
        {
          type: "selectbox",
          name: "openLink",
          label: "Open link in...",
          items: [
            { value: "_self", text: "Same window tab" },
            { value: "_blank", text: "New window tab" },
          ],
        },
        {
          type: "label",
          label: "Box 1 Info",
          items: [
            {
              type: "input",
              name: "boxInput1",
              inputMode: "text",
              label: "Text to show",
              placeholder: "Unsold 2020 Jeep Cherokee Offers",
            },
            {
              type: "urlinput",
              name: "imgSrc1",
              filetype: "image",
              label: "Source",
              disabled: false,
            },
            {
              type: "input",
              name: "imgAlt1",
              inputMode: "text",
              label: "Image alt tag",
              placeholder: "SUV on hills",
            },
          ],
        },
        {
          type: "label",
          label: "Box 2 Info",
          items: [
            {
              type: "input",
              name: "boxInput2",
              inputMode: "text",
              label: "Text to show",
              placeholder: "2020 Jeep Grand Cherokee Offers",
            },
            {
              type: "urlinput",
              name: "imgSrc2",
              filetype: "image",
              label: "Source",
              disabled: false,
            },
            {
              type: "input",
              name: "imgAlt2",
              inputMode: "text",
              label: "Image alt tag",
              placeholder: "SUV on hills",
            },
          ],
        },
        {
          type: "label",
          label: "Box 3 Info",
          items: [
            {
              type: "input",
              name: "boxInput3",
              inputMode: "text",
              label: "Text to show",
              placeholder: "Unsold Jeep Grand Cherokee",
            },
            {
              type: "urlinput",
              name: "imgSrc3",
              filetype: "image",
              label: "Source",
              disabled: false,
            },
            {
              type: "input",
              name: "imgAlt3",
              inputMode: "text",
              label: "Image alt tag",
              placeholder: "SUV on hills",
            },
          ],
        },
        {
          type: "label",
          label: "Box 4 Info",
          items: [
            {
              type: "input",
              name: "boxInput4",
              inputMode: "text",
              label: "Text to show",
              placeholder: "Jeep Cherokee Offers Near Me",
            },
            {
              type: "urlinput",
              name: "imgSrc4",
              filetype: "image",
              label: "Source",
              disabled: false,
            },
            {
              type: "input",
              name: "imgAlt4",
              inputMode: "text",
              label: "Image alt tag",
              placeholder: "SUV on hills",
            },
          ],
        },
      ],
    },
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "submit",
        name: "submit",
        text: "Add",
        primary: true,
      },
    ],
    onSubmit: api => {
      dialogData.data = api.getData();
      const parentElement = tinymce.activeEditor.selection.getNode().nodeName.toLowerCase();

      const templateToAdd = getMultiButtonCtaWithImages(dialogData);
      const shortcodeWrapper = getShortcodeWrapper(uuid, shortcodeOnClick, templateToAdd);

      addShortcodeToEditor(shortcodeWrapper, uuid, parentElement, api);
      api.close();
    },
  };

  const firstStepWindowConfig = {
    title: "Multi CTA Buttons with images",
    body: {
      type: "panel",
      items: [
        {
          type: "selectbox",
          name: "quantity",
          label: "Select the quantity of buttons",
          items: [
            { value: "4", text: "4" },
            { value: "5", text: "5" },
          ],
        },
      ],
    },
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "submit",
        name: "submit",
        text: "Add",
        primary: true,
      },
    ],
    onSubmit: api => {
      const data = api.getData();
      dialogData.quantity = data.quantity;

      if (data.quantity === "5") {
        mainShortcodeConfig.body.items.push({
          type: "label",
          label: "Box 5 Info",
          items: [
            {
              type: "input",
              name: "boxInput5",
              inputMode: "text",
              label: "Text to show",
              placeholder: "Free Bank Accounts That Offer Large Cash Bonuses",
            },
            {
              type: "urlinput",
              name: "imgSrc5",
              filetype: "image",
              label: "Source",
              disabled: false,
            },
            {
              type: "input",
              name: "imgAlt5",
              inputMode: "text",
              label: "Image alt tag",
              placeholder: "SUV on hills",
            },
          ],
        });
      }
      api.redial(mainShortcodeConfig);
    },
  };
  tinymce.activeEditor.windowManager.open(firstStepWindowConfig);
};

export { multiButtonWithImagesConfig };
